module.exports = __webpack_public_path__ + "img/bakery.eb9d0913.png";